// Custom logic for this product template
document.addEventListener("DOMContentLoaded", function () {

  // ==============================================
  // 1. SHOW/HIDE FINISH OPTIONS BASED ON MATERIAL
  // ==============================================

  // Material selectors (Paper / Canvas)
  var materialRadios = document.querySelectorAll('input[name="option-0"]');
  // Finish selectors (White Border, Deckled, Rolled, Stretched)
  var finishRadios = document.querySelectorAll('input[name="option-2"]');

  var finishItems = [];

  // Build a map connecting each finish option to its material type
  finishRadios.forEach(function (radio) {
    var wrapper = radio.closest(".swatch-element") || radio.parentElement;
    if (!wrapper) return;

    var value = (radio.value || "").toLowerCase();
    var materialType = null;

    // Determine which material each finish option belongs to
    if (value.includes("white border") || value.includes("deckled")) {
      materialType = "paper";
    } else if (value.includes("rolled") || value.includes("stretched")) {
      materialType = "canvas";
    }

    finishItems.push({
      radio: radio,
      wrapper: wrapper,
      materialType: materialType
    });
  });

  // Filters finish options when Material changes
  function applyFinishFilter() {
    var selectedMaterial = document.querySelector('input[name="option-0"]:checked');
    if (!selectedMaterial) return;

    var selected = (selectedMaterial.value || "").toLowerCase();
    var firstVisible = null;

    finishItems.forEach(function (item) {
      if (!item.materialType || !item.wrapper) return;

      // Show only finishes belonging to the selected material
      if (item.materialType === selected) {
        item.wrapper.style.display = "";
        if (!firstVisible && !item.radio.disabled) {
          firstVisible = item.radio;
        }
      } else {
        item.wrapper.style.display = "none";
        // Uncheck hidden option
        if (item.radio.checked) {
          item.radio.checked = false;
        }
      }
    });

    // Auto-select first valid finish option if none is selected
    var checkedFinish = document.querySelector('input[name="option-2"]:checked');
    if (!checkedFinish && firstVisible) {
      firstVisible.checked = true;
      firstVisible.dispatchEvent(new Event("change", { bubbles: true }));
      firstVisible.dispatchEvent(new Event("click", { bubbles: true }));
    }

    updateVariantDescription();
  }

  materialRadios.forEach(function (radio) {
    radio.addEventListener("change", applyFinishFilter);
  });

  // ==============================================
  // 2. DYNAMIC VARIANT DESCRIPTION (FROM METAFIELD)
  // ==============================================

  // Read product variants from Shopify JSON
  var productJsonEl =
    document.getElementById("WH-ProductJson-product-template") ||
    document.querySelector("script.product-json");

  var productData = null;
  if (productJsonEl) {
    try {
      productData = JSON.parse(productJsonEl.textContent.trim());
    } catch (e) {
      productData = null;
    }
  }

  // Read the dynamically generated metafield descriptions (HTML)
  var descScript = document.querySelector('script[id^="variant-descriptions-"]');
  var variantDescriptions = null;

  if (descScript) {
    try {
      variantDescriptions = JSON.parse(descScript.textContent.trim());
    } catch (e) {
      variantDescriptions = null;
    }
  }

  // Match current selection to an actual Shopify variant
  function getCurrentVariant() {
    if (!productData || !productData.variants) return null;

    var o0 = document.querySelector('input[name="option-0"]:checked');
    var o1 = document.querySelector('input[name="option-1"]:checked');
    var o2 = document.querySelector('input[name="option-2"]:checked');

    var opt1 = o0 ? o0.value : null; // Material
    var opt2 = o1 ? o1.value : null; // Size
    var opt3 = o2 ? o2.value : null; // Finish

    return (
      productData.variants.find(function (v) {
        return v.option1 === opt1 && v.option2 === opt2 && v.option3 === opt3;
      }) || null
    );
  }

  // Update the on-page HTML description box
  function updateVariantDescription() {
    var box = document.querySelector(".variant-dynamic-description");
    if (!box || !productData || !variantDescriptions) return;

    var variant = getCurrentVariant();
    if (!variant) return;

    // Get description HTML based on variant ID
    var desc = variantDescriptions[String(variant.id)];

    if (desc) {
      box.innerHTML = desc;
      box.style.display = "block";
    } else {
      box.innerHTML = "";
      box.style.display = "none";
    }
  }

  // Listen for any option change
  var optionInputs = document.querySelectorAll(
    'input[name="option-0"], input[name="option-1"], input[name="option-2"]'
  );

  optionInputs.forEach(function (input) {
    input.addEventListener("change", updateVariantDescription);
  });

  // Initial run
  applyFinishFilter();
  updateVariantDescription();
});
